import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SampleTrackingStorage } from '../../sample-tracking-storage';
import { Observable } from 'rxjs';
import { UrlBuilder } from '../../../core';
import { SampleSearchService, accessionNoValidation, accessionNoAndContainerValidation } from './sample-search-service';

@Component({
    selector: 'app-samples-search',
    template: require('./samples-search.component.html'),
    styles: [require('./samples-search.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SamplesSearchComponent {

    public searchForVisit: FormControl = new FormControl('', [accessionNoValidation()]);
    public searchForVisitError: string;
    public showLoadingForVisit: boolean;

    public searchForSample: FormControl = new FormControl('', [accessionNoAndContainerValidation()]);
    public searchForSampleError: string;
    public showLoadingForSample: boolean;

    constructor(
        private sampleTrackingStorage: SampleTrackingStorage,
        private changeDectRef: ChangeDetectorRef,
        private urlBuilder: UrlBuilder,
        private sampleSearchService: SampleSearchService
    ) {
        this.searchForVisit.valueChanges.subscribe(() => { this.searchForVisitError = ''; });
        this.searchForSample.valueChanges.subscribe(() => { this.searchForSampleError = ''; });
    }

    public onVisitSearchClick() {
        this.searchForVisitError = '';

        if (!this.searchForVisit.value.trim()) {
            this.searchForVisitError = 'Enter valid AccessionNo to search.';
            return;
        }
        this.showLoadingForVisit = true;
        this.sampleTrackingStorage.getSampleSearch(this.searchForVisit.value.trim())
            .subscribe(result => {
                if (!result.isError) {
                    this.sampleTrackingStorage.sampleSearchData = new Observable(ob => ob.next(result.accessionContainerData));
                    this.urlBuilder
                        .esa()
                        .sampletracking()
                        .visitDetails()
                        .navigate();
                } else {
                    this.searchForVisitError = result.errorMsg;
                }
                this.showLoadingForVisit = false;
                this.changeDectRef.markForCheck();
            });
    }

    public onSampleSearchClick() {

        this.searchForSampleError = '';

        const sampleSearchValue = this.searchForSample.value.replace('-', '').trim();

        if (!sampleSearchValue) {
            this.searchForSampleError = 'Accession and Container No cannot be empty.';
            return;
        }

        let accessionNo = '';
        let containerNo = 0;

        ({ accessionNo, containerNo } = this.sampleSearchService.getAccessionAndContainerNo(sampleSearchValue, accessionNo, containerNo));

        const containerNoValidationMsg = this.sampleSearchService.validateContainerNo(containerNo);

        if (containerNoValidationMsg) {
            this.searchForSampleError = containerNoValidationMsg;
            return;
        }

        this.showLoadingForSample = true;
        this.sampleTrackingStorage.getSampleSearch(accessionNo, containerNo)
            .subscribe(result => {
                if (!result.isError) {
                    this.sampleTrackingStorage.sampleSearchData = new Observable(ob => ob.next(result.accessionContainerData));
                    this.urlBuilder
                        .esa()
                        .sampletracking()
                        .sampleDetails(containerNo)
                        .navigate();
                } else {
                    this.searchForSampleError = result.errorMsg;
                }
                this.showLoadingForSample = false;
                this.changeDectRef.markForCheck();
            });
    }

    public onSearchForSampleKeyDownEvent() {
        setTimeout(() => {
            let value = this.searchForSample.value.trim();

            if (value && (value.indexOf('-') >= 0)) {
                value = value.replace('-', '');
                this.searchForSample.patchValue(value);
            }

            if (value && (value.length > 7 && value.length <= 10)) {
                this.searchForSample.patchValue([value.slice(0, 7), '-', value.slice(7)].join(''));
            }

            if (value && value.length > 10) {
                this.searchForSample.patchValue([value.slice(0, 10), '-', value.slice(10)].join(''));
            }
        });
    }

}
